import { render } from "./FormTerminal.vue?vue&type=template&id=4c23476c&ts=true"
import script from "@/composables/pages/master-setting/city-terminal/FormTerminalComposable?vue&type=script&lang=ts"
export * from "@/composables/pages/master-setting/city-terminal/FormTerminalComposable?vue&type=script&lang=ts"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__